<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Business"
                            prop="business"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.business"
                                placeholder="Business"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Code" prop="code" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.code"
                                placeholder="Code"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                    <el-form-item label="User Name" prop="user_id" size="small">
                            <el-select
                                v-model="addForm.user_id"
                                placeholder="Please input user"
                                filterable
                                clearable
                                :filter-method="userSelect"
                                :remote="true"
                            >
                                <el-option
                                    v-for="item in userList"
                                    :key="item.id"
                                    :label="item.username"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="ERP USER ID" prop="erp_user_id" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.erp_user_id"
                                placeholder="ERP USER ID"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                business: "",
                code: "",
                user_id: "",
                erp_user_id: "",
            },
            userList:[],
        };
    },
    methods: {
        save() {
            this.loading = true;
            cmofferApi
                .businessCode(
                    {
                        ...this.addForm,
                    },
                    "post"
                )
                .then((res) => {
                    this.loading = false;
                    this.closeDialog();
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.$parent[this.funcName]();
                });
        },
        closeDialog() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        userSelect(val){
            cmofferApi.userSelect({keyword: val,role:1}, "get").then((res) => {
                if (res) {
                    this.userList = res.data;
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
